"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-play viewbox="0 0 16 16"><path fill=currentColor fill-rule=evenodd d="M16 8L0 16V0z"></path></symbol>';
};